<template>
  <v-dialog
    v-model="open"    
    max-width="45%"
    persistent
  >
    <v-card tile>
      <v-card-title>
        {{ $t('SelectAddressType') }}
      </v-card-title>
      <v-card-text>
        <v-form 
          ref="form"
        >
          <v-select
            v-model="selectedAddressType"
            :items="filteredAddressTypes"
            :label="$t('AddressType')"
            :rules="addressTypeRules"
            :disabled="isEditing"
            required
          ></v-select>

          <!-- Add new address fields -->
          <template v-if="selectedAddressType">
            <CountryCodeSelector
              ref="countrycodesselect"
              v-model="addressData.countryCode"
              :selected-country="addressData.countryCode"
              select-type="fullname"
              :rules="[v => !!v || $t('Required')]"
              required
              @select-countrychange="handleCountryChange"
            />
            
            <v-text-field
              v-model="addressData.addressLine1"
              :label="$t('AddressLine1')"
              :rules="[v => !!v || $t('Required')]"
              required
            ></v-text-field>
            <v-text-field
              v-model="addressData.addressLine2"
              :label="$t('AddressLine2')"
            ></v-text-field>
            <v-text-field
              v-model="addressData.city"
              :label="$t('City')"
              :rules="[v => !!v || $t('Required')]"
              required
            ></v-text-field>
            <v-text-field
              v-model="addressData.stateProvince"
              :label="$t('StateProvince')"
              required
            ></v-text-field>
            <v-text-field
              v-model="addressData.postCode"
              :label="$t('PostCode')"
              :rules="[v => !!v || $t('Required')]"
              required
            ></v-text-field>
          </template>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn     
          text
          @click="onHide"
        >
          {{ $t('Close') }}
        </v-btn>
        <v-btn
          color="primary"     
          class="mx-1"
          depressed          
          @click="onSave"
        >
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CountryCodeSelector from '../CountryCodeSelector.vue'

export default {
  name: 'SelectAddressTypeDialog',
  components: {
    CountryCodeSelector
  },
  props: {
    existingAddressTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      open: false,
      isEditing: false,
      selectedAddressType: null,
      addressTypes: [
        { text: this.$t('Primaryaddress'), value: 'primaryAddress' },
        { text: this.$t('Secondaryaddress'), value: 'secondaryAddress' },
        { text: this.$t('Invoicingaddress'), value: 'invoicingAddress' }
      ],
      addressData: this.getEmptyAddressData(),
      addressTypeRules: [
        v => !!v || this.$t('Required')
      ]
    }
  },
  computed: {
    filteredAddressTypes() {
      return this.addressTypes.filter(type => 
        this.isEditing || !this.existingAddressTypes.includes(type.value)
      )
    }
  },
  methods: {
    getEmptyAddressData() {
      return {
        countryCodeId: '',
        countryCode: '',
        countryText: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateProvince: '',
        postCode: ''
      }
    },
    handleCountryChange(value) {
      this.addressData.countryCode = value
      const countryId = this.$refs.countrycodesselect.getCountryId(value)
      this.addressData.countryCodeId = countryId
      const selectedCountry = this.$refs.countrycodesselect.countryCodes.find(
        country => country.value === value
      )
      this.addressData.countryText = selectedCountry ? selectedCountry.text : ''
    },
    editAddress(type, address) {
      this.addressData = {
        countryCodeId: address.countryCodeId || '',
        countryCode: address.countryCode || '',
        countryText: address.countryText || '',
        addressLine1: address.addressLine1 || '',
        addressLine2: address.addressLine2 || '',
        city: address.city || '',
        stateProvince: address.stateProvince || '',
        postCode: address.postCode || ''
      }
      this.selectedAddressType = type
      this.isEditing = true
      this.open = true
    },
    onHide() {
      if (this.rejectFnc) {
        this.rejectFnc()
      }
      this.resetForm()
    },
    onSave() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        return
      }
      
      const savedAddress = {
        countryCodeId: this.addressData.countryCodeId,
        countryCode: this.addressData.countryCode,
        countryText: this.addressData.countryText,
        addressLine1: this.addressData.addressLine1,
        addressLine2: this.addressData.addressLine2,
        city: this.addressData.city,
        stateProvince: this.addressData.stateProvince,
        postCode: this.addressData.postCode
      }

      this.$emit('addresstypeselected', {
        type: this.selectedAddressType,
        address: savedAddress
      })
      this.resetForm()
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.addressData = this.getEmptyAddressData()
      this.selectedAddressType = null
      this.isEditing = false
      this.open = false
    }
  }
}
</script> 